import { format_id, format_text, format_textdelete } from "../../core/function/function-generic";

interface PropsTransaction {
    nameMoney: string;
    address: string;
    red?: string;
}

export const FromTransaction = ({ nameMoney, address, red }: PropsTransaction) => {
    console.log({ nameMoney, address, red })
    const arrAddress = address ? address.trim().split(' ') : ''
    return (
        <>
            <div className="">
                <p className='text-16-lh-normal text-start-import'>
                    {format_text(nameMoney) + ' '} {red ? red : ''}
                </p>
                <span className="text-13-500">{address ? format_id(address).trim() : ''} </span>
                {
                    arrAddress[1] && (
                        <span className="text-13-500 text-start-import">
                            <b className="text-16-lh-normal pr-2">Id</b>
                            {arrAddress[1]}
                        </span>
                    )
                }
            </div>
        </>

    )
}

interface PropsToTransaction {
    nameBank: string;
    address: string;
}

export const ToTransaction = ({ nameBank, address }: PropsToTransaction) => {

    const isCustodial: boolean = address.includes('NO CUSTODIAL')
    const arrAddress = (isCustodial) ? address : address.trim().split(' ')

    return (
        <>
            <div className="">
                <p className='text-16-lh-normal text-start-import'>
                    {address.includes('NO CUSTODIAL') ? format_textdelete(nameBank) : format_text(nameBank) + ' '}
                </p>
                <div className="w-full flex flex-col">
                    <span className="text-13-500 text-start-import">{arrAddress[0] ? arrAddress[0] : address} </span>
                    {
                        arrAddress[1] && !isCustodial ? (
                            <span className="text-13-500 text-start-import">
                                <b className="text-16-lh-normal pr-2">Id</b>
                                {arrAddress[1]}
                            </span>
                        ) : (
                            <span className="text-13-500 text-start-import">
                                {address.split(" ")[1]+' '+address.split(" ")[2]}
                            </span>
                        )
                    }
                </div>
            </div>
        </>

    )
}